// Адреса рисованной графики карты мира — отдельно от рендера, чтобы экран загрузки мог заранее
// скачать их, не подтягивая в стартовую сборку весь код карты.
import { castleSkinStage } from '@sk/shared';

export const WORLD_ART_V = 'v4';
/** Новая версия картинок наборов замков: браузеры не покажут старые из кеша. */
const CASTLE_SET_V = 's2';
export const CASTLE_ART_LEVELS = [1, 5, 10, 15, 20] as const;

const MARKERS = [
  'abandoned',
  'barbarian_camp',
  'boss',
  'capital',
  'castle',
  'shield',
  'keypoint',
  'neutral_city',
  'pirate_haven',
  'port',
  'deposit_silver',
  'deposit_wood',
  'deposit_stone',
  'deposit_food',
  'deposit_iron',
];

/** Картинка замка: set — набор расы или скина, без него — заводской замок. */
export function castleArtUrl(level: number, set?: string | null): string {
  if (set) return `/art/world/castles/${set}/castle_${castleSkinStage(level)}.webp?${CASTLE_SET_V}`;
  const stage = [...CASTLE_ART_LEVELS].reverse().find((lv) => level >= lv) ?? 1;
  return `/art/world/castles/castle_${stage}.png?${WORLD_ART_V}`;
}

/** Все маркеры карты (для предзагрузки при входе). */
export const MAP_MARKER_URLS = MARKERS.map((m) => `/art/world/markers/${m}.webp?${WORLD_ART_V}`);

/** Все картинки замков на карте (для предзагрузки при входе). */
export function mapCastleArtUrls(): string[] {
  return CASTLE_ART_LEVELS.map((lv) => `/art/world/castles/castle_${lv}.png?${WORLD_ART_V}`);
}
